import { render, staticRenderFns } from "./SettingPrivilege.vue?vue&type=template&id=4af860d1&scoped=true&"
import script from "./SettingPrivilege.vue?vue&type=script&lang=js&"
export * from "./SettingPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./SettingPrivilege.vue?vue&type=style&index=0&id=4af860d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af860d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
